import { useEffect, useState } from "react";

const ButtonCheckbox = ({ label, value, onClick, isChecked = false }) => {
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => setChecked(isChecked), [isChecked]);

  const toggleChecked = () => {
    setChecked(!checked);
    onClick(value);
  };

  return (
    <>
      <button
        onClick={toggleChecked}
        className={`px-4 py-2 m-[0.3rem] ms-0 rounded-full border-1 text-[12px] focus:outline-none
                ${
                  checked
                    ? "bg-[#316BCB] text-[#fff] border-[#316BCB]"
                    : "bg-white text-black border-[#BDBDBD] "
                }`}
      >
        {label}
      </button>
    </>
  );
};

export default ButtonCheckbox;
